import { LOGO_URL, fetchRatingsSummary } from 'webwinkelkeur-api';

/**
 * WebwinkelkeurRating
 * @description Fills the shop rating bar (score badge, stars, review count)
 * with the shop-wide totals from the WebWinkelKeur ratings summary API.
 * The element stays hidden until the data has loaded.
 */
class WebwinkelkeurRating extends HTMLElement {
  async connectedCallback() {
    try {
      this.render(await fetchRatingsSummary());
      this.loadLogo();
      this.hidden = false;
    }
    catch (error) {
      // Leave the block hidden when the API is unavailable
      console.warn('WebWinkelKeur rating could not be loaded:', error);
    }
  }

  // The shop-wide rating_average uses a 0-10 scale
  render({ rating_average: rating, amount }) {
    const locale = this.dataset.locale;

    this.querySelector('[data-wwk-rating-value]').textContent = rating.toLocaleString(locale, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });

    this.querySelector('[data-wwk-rating-stars]').style.inlineSize = `${rating * 10}%`;

    const count = this.querySelector('[data-wwk-rating-count]');
    count.textContent = count.textContent.replace('[count]', amount.toLocaleString(locale));
  }

  // Swap the bundled logo for the one WebWinkelKeur serves themselves, so a
  // rebrand shows up without a theme update. The swap only happens once the
  // remote image has loaded; on failure the bundled fallback stays in place.
  loadLogo() {
    const logo = this.querySelector('[data-wwk-rating-logo]');
    if (!logo) return;

    const remote = new Image();
    remote.addEventListener('load', () => {
      logo.src = LOGO_URL;
    });
    remote.src = LOGO_URL;
  }
}

if (!customElements.get('webwinkelkeur-rating')) {
  customElements.define('webwinkelkeur-rating', WebwinkelkeurRating);
}
